import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/jumin',
    SEARCH: '/cms/jumin',
    DELETE: '/cms/jumin',
    UPDATE: '/cms/jumin'
}

export default {
    juminAdd (jumin, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.ADD),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: jumin,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    updateJumin (contentId, jumin, uploadProgressHandler) {
        return remote.request({
          url: remote.getUrl(URL.UPDATE) + '/' + contentId,
          method: remote.METHOD.POST,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          data: jumin,
          timeout: 3600000,
          onUploadProgress: uploadProgressHandler,
        });
    },
    searchJumin (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url,
        })
    },
    searchJuminDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
        })
    },
    removeJumin (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
